<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex :class="accountPayable.id ? 'sm6' : 'sm12'">
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="false"
                >
                  <v-text-field
                    slot="activator"
                    label="Issue Date"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    :rules="rules.issueDateRules"
                  ></v-text-field>
                  <v-date-picker v-model="issueDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="accountPayable.id">
                <v-autocomplete
                  v-model="accountPayable.accountPayableStatus"
                  :items="statusList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :rules="rules.statusRules"
                  :disabled="status != 'DRAFT'"
                ></v-autocomplete>
              </v-flex>

              <v-flex sm4>
                <v-select
                  v-model="accountPayable.apType"
                  :items="accountPayableTypes"
                  color="blue-grey lighten-2"
                  label="Choose Account Payable Type..."
                  item-text="label"
                  menu-props="auto"
                  item-value="value"
                  :rules="rules.accountPayableTypeRules"
                  @change="changeType(), changeOperationType()"
                  :disabled="status != 'DRAFT'"
                ></v-select>
              </v-flex>

              <v-flex sm4>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="status != 'DRAFT'"
                >
                  <v-text-field
                    slot="activator"
                    label="From Date"
                    type="text"
                    prepend-icon="event"
                    v-model="fromDate"
                    :rules="rules.fromDateRules"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="fromDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm4>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="status != 'DRAFT'"
                >
                  <v-text-field
                    slot="activator"
                    label="To Date"
                    type="text"
                    prepend-icon="event"
                    v-model="toDate"
                    :rules="rules.toDateRules"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="toDate"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex :class="isPaymentType() ? 'sm4' : 'sm12'">
                <v-select
                  :items="shopList"
                  label="Select Shop"
                  item-text="name"
                  item-value="id"
                  v-model="accountPayable.shopId"
                  @change="changeShop()"
                  :disabled="status != 'DRAFT'"
                  :rules="rules.shopRules"
                  :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                ></v-select>
              </v-flex>

              <v-flex sm8 class="px-5" v-if="isPaymentType()">
                <v-layout>
                  <v-flex xs10>
                    <v-text-field
                      label="PO NO"
                      clearable
                      @click:clear="clearPONO"
                      readonly
                      v-model="accountPayable.poNo"
                      :disabled="status != 'DRAFT'"
                      :rules="rules.poNoRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-btn
                      outline
                      color="warning"
                      :disabled="status != 'DRAFT' || !accountPayable.shopId"
                      @click="showPurchaseOrderListDialog = true"
                    >
                      Search
                      <v-icon dark>search</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex sm6>
                <v-text-field
                  label="Choose Supplier ..."
                  v-model="supplierName"
                  @click="openSupplierListDialog()"
                  :rules="rules.supplierRules"
                  readonly
                  :disabled="status != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-select
                  :items="currencyList"
                  v-model="accountPayable.currencyId"
                  label="Select Currency"
                  item-text="code"
                  item-value="id"
                  @change="changeCurrency()"
                  :disabled="status != 'DRAFT'"
                  :rules="rules.currencyRules"
                ></v-select>
              </v-flex>

              <v-flex sm6 v-if="!isSupplierAdvanced()">
                <v-text-field
                  label="Choose Advanced Issue No ..."
                  clearable
                  @click:clear="clearAdvanceNo"
                  @click="showAdvancedAPListDialog = !showAdvancedAPListDialog"
                  readonly
                  v-model="accountPayable.advancedIssueNo"
                  :disabled="status != 'DRAFT' || !isAdvancePayment()"
                  :rules="isAdvancePayment() ? rules.invoiceNoRules : []"
                  
                ></v-text-field>
              </v-flex>

              <v-flex :class="isSupplierAdvanced() ? 'sm12' : 'sm6'">
                <v-text-field
                  name="exchangeRateMMK"
                  label="Exchange Rate(MMK)"
                  v-model="accountPayable.exchangeRateMMK"
                  :rules="rules.exchangeRateMMKRules"
                  @input="changeExchangeRateMMK()"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="isOperationSetting()">
                <v-select
                  :items="operationSettingList"
                  label="Operation Setting"
                  v-model="accountPayable.operationSettingId"
                  item-text="name"
                  item-value="id"
                  :hide-no-data="true"
                  :rules="rules.required('Operation setting')"
                ></v-select>
              </v-flex>
              <v-flex :class="isPaymentType() ? 'sm6' : 'sm12'">
                <v-layout row wrap>
                  <v-flex sm12>
                    <v-text-field
                      name="cashAmount"
                      label="Cash Amount"
                      v-model="accountPayable.cashAmount"
                      :rules="rules.cashAmountRules"
                      :readonly="isPaymentType()"
                      @input="calculateCashAmountMMK()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12>
                    <v-text-field
                      name="cashAmountMMK"
                      label="Cash Amount(MMK)"
                      v-model="accountPayable.cashAmountMMK"
                      readonly
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm6 class="px-5" v-if="isPaymentType()">
                <v-card class="mt-4">
                  <v-card-text class="font-weight-bold">
                    <span>Total Payable Amount</span>
                    <span class="ml-5">
                      :
                      <v-chip>{{ totalPayableAmount | decFormat(6) }}</v-chip>
                    </span>
                    <br />
                    <span>Total Payable Amount(MMK)</span>
                    <span class="ml-2"
                      >:
                      <v-chip>{{
                        totalPayableAmountMMK | decFormat(6)
                      }}</v-chip>
                    </span>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="chequeNo"
                  label="Cheque No"
                  v-model="accountPayable.chequeNo"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="remark"
                  label="Remark"
                  v-model="accountPayable.remark"
                  type="text"
                  :rules="rules.remarkRules"
                ></v-text-field>
              </v-flex>

              <v-flex sm6 v-if="accountPayable.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="accountPayable.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="accountPayable.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="accountPayable.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="accountPayable.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="accountPayable.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex v-if="isPaymentType()">
                <v-flex sm12 v-if="payableAmtErr">
                  <span class="red--text">{{ payableAmtErr }}</span>
                </v-flex>
                <v-data-table
                  v-if="accountPayable.accountPayableItemList.length > 0"
                  :headers="itemHeaders"
                  :items="accountPayable.accountPayableItemList"
                  dense
                >
                  <template v-slot:items="props">
                    <td>
                      {{ props.item.productCode }}
                    </td>
                    <td>
                      {{ props.item.productName }}
                    </td>
                    <td>
                      {{ props.item.factorUnitName }}
                    </td>

                    <td>
                      {{ props.item.qty | decFormat(6) }}
                    </td>

                    <td>
                      {{ props.item.price | decFormat(6) }}
                    </td>

                    <td>
                      {{ props.item.priceMMK | decFormat(6) }}
                    </td>

                    <td v-if="isItemDiscount">
                      {{ props.item.discountPercent | decFormat }}
                    </td>

                    <td>
                      {{ props.item.amount | decFormat(6) }}
                    </td>

                    <td>
                      {{ props.item.amountMMK | decFormat(6) }}
                    </td>

                    <td>
                      <v-text-field
                        v-model="props.item.paidPercent"
                        @input="changePaidPercent(props.item)"
                        :readonly="status != 'DRAFT'"
                        :rules="rules.percentageRules"
                      ></v-text-field>
                    </td>

                    <td>
                      {{ props.item.paidAmount | decFormat(6) }}
                    </td>

                    <td>
                      <v-text-field
                        v-model="props.item.remark"
                        :readonly="status != 'DRAFT'"
                        :rules="rules.remarkRules"
                      ></v-text-field>
                    </td>

                    <td>
                      <v-btn
                        icon
                        @click="
                          removeAccountPayableItem(
                            props.item.productId,
                            props.item.id
                          )
                        "
                        :disabled="
                          status != 'DRAFT' ||
                            accountPayable.accountPayableDetailAssetList
                              .length <= 1
                        "
                      >
                        <v-icon>cancel</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex v-if="isPaymentType()">
                <v-flex sm12 v-if="payableAmtErr">
                  <span class="red--text">{{ payableAmtErr }}</span>
                </v-flex>
                <v-data-table
                  v-if="accountPayable.accountPayableDetailAssetList.length > 0"
                  :headers="assetHeaders"
                  :items="accountPayable.accountPayableDetailAssetList"
                  dense
                >
                  <template v-slot:items="props">
                    <td>
                      {{ props.item.assetName }}
                    </td>
                    <td>
                      {{ props.item.assetUnitName }}
                    </td>
                    <td>
                      {{ props.item.qty | decFormat(6) }}
                    </td>

                    <td>
                      {{ props.item.price | decFormat(6) }}
                    </td>

                    <td>
                      {{ props.item.priceMMK | decFormat(6) }}
                    </td>

                    <td v-if="isItemDiscount">
                      {{ props.item.discountPercent | decFormat }}
                    </td>

                    <td>
                      {{ props.item.amount | decFormat(6) }}
                    </td>
                    <td>
                      {{ props.item.amountMMK | decFormat(6) }}
                    </td>
                    <td>
                      <v-text-field
                        v-model="props.item.paidPercent"
                        @input="changePaidPercent(props.item)"
                        :readonly="status !== 'DRAFT'"
                        :rules="rules.percentageRules"
                      ></v-text-field>
                    </td>
                    <td>
                      {{ props.item.paidAmount | decFormat(6) }}
                    </td>
                    <td>
                      <v-text-field
                        v-model="props.item.remark"
                        type="text"
                        :readonly="status !== 'DRAFT'"
                        :rules="rules.remarkRules"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-btn
                        icon
                        @click="
                          removeAccountPayableAssetItem(
                            props.item.assetId,
                            props.item.id
                          )
                        "
                        :disabled="
                          status !== 'DRAFT' ||
                            accountPayable.accountPayableDetailAssetList
                              .length <= 1
                        "
                      >
                        <v-icon>cancel</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="
                      !valid ||
                      status != 'DRAFT' ||
                      payableAmtErr ||
                      saveLoading
                        ? true
                        : false
                    "
                    @click="onSave"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <SupplierDialog
      :showSupplierListDialog="showSupplierListDialog"
      :poSupplierIds="purchaseOrderSupplierIds"
      @changeSupplier="changeSupplier($event)"
    ></SupplierDialog>
    <PurchaseOrderListDialog
      :showDialog="showPurchaseOrderListDialog"
      :hideDateFilters="true"
      :params="{
        fromIssueDate: fromDate,
        toIssueDate: toDate,
        shopId: accountPayable.shopId,
        checkUnpaid: true,
      }"
      @close="closePurchaseOrderDialog"
    ></PurchaseOrderListDialog>

    <!--advanced issue no-->
    <AdvancedAccountPayableDialog
      :showAdvancedAPListDialog="showAdvancedAPListDialog"
      :fromDate="fromDate"
      :toDate="toDate"
      :supplierId="accountPayable.supplierId"
      :currencyId="accountPayable.currencyId"
      :shopId="accountPayable.shopId"
      @changeAccountPayable="changeAdvancedAccountPayable($event)"
    ></AdvancedAccountPayableDialog>

    <!-- final message dialog -->
    <v-dialog
      v-model="messageDialogBox"
      max-width="600px"
      @keydown.enter="messageDialogBox = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3 v-html="responseError"></h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  AccountPayable,
  AccountPayableDetailAsset,
  AccountPayableItem,
} from "../../../models/model";
import { commonService } from "../../../services/common-service";
import { AccountPayableFormRules } from "../../../helpers/validation-rules";
import { accountPayableService } from "../../../services/account-payable-service";
import { shopService } from "../../../services/shop-service";
import SupplierDialog from "../../../components/accountpayable/accountpayabledetail/SupplierDialog";
import AdvancedAccountPayableDialog from "../../../components/accountpayable/accountpayabledetail/AdvancedAccountPayableDialog";
import { currencyService } from "../../../services/currency-service";
import PurchaseOrderListDialog from "../../purchase-order/PurchaseOrderListDialog.vue";
import { operationSettingService } from "../../../services/operation-setting-service";

export default {
  name: "AccountPayableDetail",
  components: {
    SupplierDialog,
    AdvancedAccountPayableDialog,
    PurchaseOrderListDialog,
  },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    breadcrumbs: [
      {
        text: "Account Payable",
        disabled: false,
        to: "accountpayables",
      },
      {
        text: "Account Payable Detail",
        disabled: true,
      },
    ],
    valid: true,
    statusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    accountPayableTypes: [
      { label: "Purchase Payment", value: "PURCHASE_PAYMENT" },
      { label: "Advance Purchase Payment", value: "ADVANCE_PURCHASE_PAYMENT" },
      { label: "Discount", value: "DISCOUNT" },
      { label: "Supplier Advanced", value: "SUPPLIER_ADVANCED" },
      { label: "Advance Repayment", value: "ADVANCE_REPAYMENT" },
    ],
    operationSettingList: [],
    type: "",
    status: "DRAFT",
    createdDate: "",
    updatedDate: "",
    fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    issueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    responseError: "",
    saveLoading: false,
    activeCustomerList: [],
    creditLevelList: [],
    tempList: [],
    shopList: [],
    totalPayableAmount: 0,
    rules: new AccountPayableFormRules(),
    accountPayable: new AccountPayable(),
    oldaccountPayable: new AccountPayable(),
    accountPayableItem: new AccountPayableItem(),
    accountPayableDetailAsset: new AccountPayableDetailAsset(),
    messageDialogBox: false,
    showSupplierListDialog: false,
    showPurchaseOrderListDialog: false,
    showAdvancedAPListDialog: false,
    queryParams: {
      supplierId: "",
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      poNo: "",
      shopId: "",
    },
    itemHeaders: [
      { text: "Code", value: "productCode", sortable: false },
      { text: "Name", value: "productName", sortable: false },
      { text: "Unit", value: "factorUnitName", sortable: false },
      { text: "Qty", value: "qty", sortable: false, align: "right" },
      { text: "Unit Cost", value: "price", sortable: false, align: "right" },
      {
        text: "Unit Cost (MMK)",
        value: "priceMMK",
        sortable: false,
        align: "right",
      },
      { text: "Amount", value: "amount", sortable: false, align: "right" },
      {
        text: "Amount (MMK)",
        value: "amountMMK",
        sortable: false,
        align: "right",
      },
      { text: "Paid %", value: "paidPercent", sortable: false },
      {
        text: "Paid Amount",
        value: "paidAmount",
        sortable: false,
        align: "right",
      },
      { text: "Remark", value: "remark", sortable: false },
      { text: "Action", value: "action", sortable: false },
    ],
    assetHeaders: [
      { text: "Asset Name", value: "assetName", sortable: false },
      { text: "Unit", value: "assetUnitName", sortable: false },
      { text: "Qty", value: "qty", sortable: false, align: "right" },
      { text: "Unit Cost", value: "price", sortable: false, align: "right" },
      {
        text: "Unit Cost (MMK)",
        value: "priceMMK",
        sortable: false,
        align: "right",
      },
      { text: "Amount", value: "amount", sortable: false, align: "right" },
      {
        text: "Amount (MMK)",
        value: "amountMMK",
        sortable: false,
        align: "right",
      },
      { text: "Paid %", value: "paidPercent", sortable: false },
      {
        text: "Paid Amount",
        value: "paidAmount",
        sortable: false,
        align: "right",
      },
      { text: "Remark", value: "remark", sortable: false },
      { text: "Action", value: "action", sortable: false },
    ],
    showListLoading: false,
    supplierName: "",
    payableAmtErr: "",
    isItemDiscount: false,
    rowsPerPageItems: [10, 50, 100],
    totalRows: 0,
    currencyList: [],
    totalPayableAmountMMK: 0,
    purchaseOrderItems: [],
    purchaseOrderDetailAssetList: [],
    purchaseOrderSupplierIds: [],
  }),
  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.accountPayable.shopId = this.user.shopId;
    }
    const id = this.$route.params.id;
    if (id == "new") {
      // new AccountPayable
    } else {
      this.getAccountPayableDetail(id);
    }
    this.getShopList();
    this.getCurrencies();
    this.changeOperationType();
  },
  methods: {
    getCurrencies() {
      currencyService
        .getCurrencyByStatus("ACTIVE")
        .then((res) => {
          this.currencyList = res.data;
          this.setDefaultCurrencyForNewAP();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setDefaultCurrencyForNewAP() {
      if (!this.accountPayable.currencyId) {
        let currency = this.currencyList.find((c) => c.defaultCurrency == true);
        if (currency) this.accountPayable.currencyId = currency.id;
      }
    },
    getAccountPayableDetail(id) {
      accountPayableService.getAccountPayableDetail(id).then((res) => {
        this.accountPayable = res.data;
        this.isItemDiscount = this.accountPayable.isItemDiscount;
        this.status = this.accountPayable.accountPayableStatus;
        this.purchaseOrderItems = this.accountPayable.purchaseOrderItems;
        this.accountPayable.purchaseOrderItems = [];
        this.accountPayable.accountPayableItemList.forEach((item) => {
          this.calculateAmount(item);
          this.calculateAmountMMK(item);
        });
        this.accountPayable.accountPayableDetailAssetList.forEach((item) => {
          this.calculateAmount(item);
          this.calculateAmountMMK(item);
        });
        this.calculateTotalPayableAmount();
        this.createdDate = commonService.formatDate(
          new Date(this.accountPayable.createdDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.updatedDate = commonService.formatDate(
          new Date(this.accountPayable.updatedDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.issueDate = commonService.millisecondToDate(
          this.accountPayable.issueDateInMilliSeconds,
          "YYYY-MM-DD"
        );

        this.fromDate = commonService.millisecondToDate(
          this.accountPayable.fromPODateInMilliSeconds,
          "YYYY-MM-DD"
        );
        this.toDate = commonService.millisecondToDate(
          this.accountPayable.toPODateInMilliSeconds,
          "YYYY-MM-DD"
        );
        this.supplierName = this.accountPayable.supplier.companyName;
        if (
          this.accountPayable.accountPayableDetailList &&
          this.accountPayable.accountPayableDetailList.length == 1
        ) {
          let accountPayableDetail = this.accountPayable
            .accountPayableDetailList[0];
          this.accountPayable.poNo = accountPayableDetail.poNO;
        }
        this.changeOperationType();
        this.oldaccountPayable = JSON.parse(JSON.stringify(res.data));
      });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          for (const apItem of this.accountPayable.accountPayableItemList) {
            if (!this.checkPaidPercentValid(apItem)) return;
          }
          if (!this.checkCashAmountValid()) return;
          this.saveLoading = true;
          if (!this.isPaymentType()) {
            this.clearAccountPayableItemList();
          }
          this.accountPayable.issueDateInMilliSeconds = commonService.convertToMilliseconds(
            this.issueDate
          );

          this.accountPayable.fromPODateInMilliSeconds = commonService.convertToMilliseconds(
            this.fromDate
          );
          this.accountPayable.toPODateInMilliSeconds = commonService.convertToMilliseconds(
            this.toDate
          );
          this.accountPayable.creditAmount = this.totalPayableAmount;
          this.accountPayable.creditAmountMMK = this.totalPayableAmountMMK;
          accountPayableService
            .saveAccountPayable(this.accountPayable)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
                this.messageDialogBox = true;
              }
              this.saveLoading = false;
            });
        }
      }
    },

    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    clearPONO() {
      this.accountPayable.poNo = "";
      this.accountPayable.supplierId = "";
      this.supplierName = "";
      this.clearAccountPayableItemList();
      this.calculateCashAmount();
      this.calculateTotalPayableAmount();
    },

    openSupplierListDialog() {
      if (this.isSupplierAdvanced() || this.isAdvanceRepay()) {
        this.showSupplierListDialog = !this.showSupplierListDialog;
        return;
      }
      if (!this.accountPayable.poNo) return;
      let poItemsSupplierIds = this.purchaseOrderItems.filter(poi=>((poi.qty * poi.actualUnitCost) > poi.apPaidAmount)).map(
        (item) => item.supplierId
      );
      let poAssetSupplierIds = this.purchaseOrderDetailAssetList.filter(poa=>((poa.qty * poa.actualUnitCost) > poa.apPaidAmount)).map(
        (item) => item.supplierId
      );

      this.purchaseOrderSupplierIds = Array.from(
        new Set([...poItemsSupplierIds, ...poAssetSupplierIds])
      );
      this.showSupplierListDialog = !this.showSupplierListDialog;
    },
    changeSupplier(supplier) {
      this.accountPayable.supplierId = supplier.id;
      this.supplierName = supplier.companyName;
      this.showSupplierListDialog = !this.showSupplierListDialog;
      this.accountPayable.advancedIssueNo = "";
      this.prepareAccountPayableItems();
    },
    changeCurrency() {
      this.accountPayable.advancedIssueNo = "";
      this.prepareAccountPayableItems();
    },
    prepareAccountPayableItems() {
      this.clearAccountPayableItemList();

      this.purchaseOrderItems.forEach((poi) => {
        if (
          poi.currencyId == this.accountPayable.currencyId &&
          poi.supplierId == this.accountPayable.supplierId &&
          poi.qty * poi.actualUnitCost > poi.apPaidAmount
        ) {
          let apItem = new AccountPayableItem();
          apItem.productId = poi.productId;
          apItem.productCode = poi.productCode;
          apItem.productName = poi.productName;
          apItem.productUnits = poi.productUnits;
          apItem.factorUnitName = poi.factorUnitName;
          apItem.discountPercent = poi.discountPercent;
          apItem.qty = poi.qty;
          apItem.price = poi.actualUnitCost;
          this.calculatePriceMMK(apItem);
          this.calculateAmount(apItem);
          this.calculateAmountMMK(apItem);
          apItem.prevPaidPercent = poi.apPaidPercent;
          apItem.prevPaidAmount = poi.apPaidAmount;
          apItem.paidPercent = 100 - apItem.prevPaidPercent;
          this.calculatePaidAmount(apItem);
          this.accountPayable.accountPayableItemList.push(apItem);
        }
      });

      this.purchaseOrderDetailAssetList.forEach((poi) => {
        if (
          poi.currencyId == this.accountPayable.currencyId &&
          poi.supplierId == this.accountPayable.supplierId &&
          poi.qty * poi.actualUnitCost > poi.apPaidAmount
        ) {
          let apItem = new AccountPayableDetailAsset();
          apItem.assetId = poi.assetId;
          apItem.assetName = poi.assetName;
          apItem.assetUnitId = poi.unitId;
          apItem.assetUnitName = poi.unitName;
          apItem.discountPercent = poi.discountPercent;
          apItem.qty = poi.qty;
          apItem.price = poi.actualUnitCost;
          this.calculatePriceMMK(apItem);
          this.calculateAmount(apItem);
          this.calculateAmountMMK(apItem);
          apItem.prevPaidPercent = poi.apPaidPercent;
          apItem.prevPaidAmount = poi.apPaidAmount;
          apItem.paidPercent = 100 - apItem.prevPaidPercent;
          this.calculatePaidAmount(apItem);
          this.accountPayable.accountPayableDetailAssetList.push(apItem);
        }
      });
      this.calculateCashAmount();
      this.calculateTotalPayableAmount();
    },

    closePurchaseOrderDialog(purchaseOrder) {
      if (purchaseOrder && purchaseOrder.id) {
        this.clearPONO();
        this.accountPayable.poNo = purchaseOrder.issueNo;
        this.purchaseOrderItems = purchaseOrder.purchaseOrderItems;

        this.purchaseOrderDetailAssetList = purchaseOrder.purchaseOrderAssets;
      }
      this.showPurchaseOrderListDialog = false;
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.accountPayable.id) {
        this.fromDate = commonService.formatDate(new Date(), "YYYY-MM-DD");
        this.toDate = commonService.formatDate(new Date(), "YYYY-MM-DD");
        this.totalPayableAmount = 0;
        this.totalPayableAmountMMK = 0;
        this.accountPayable = new AccountPayable();
        this.supplierName = "";
      } else {
        this.accountPayable = Object.assign({}, this.oldaccountPayable);
        this.isItemDiscount = this.accountPayable.isItemDiscount;
        if (
          this.accountPayable.accountPayableDetailList &&
          this.accountPayable.accountPayableDetailList.length == 1
        ) {
          let accountPayableDetail = this.accountPayable
            .accountPayableDetailList[0];
          this.accountPayable.poNo = accountPayableDetail.poNO;
        }
        this.issueDate = commonService.millisecondToDate(
          this.accountPayable.issueDateInMilliSeconds,
          "YYYY-MM-DD"
        );

        this.fromDate = commonService.millisecondToDate(
          this.accountPayable.fromPODateInMilliSeconds,
          "YYYY-MM-DD"
        );
        this.toDate = commonService.millisecondToDate(
          this.accountPayable.toPODateInMilliSeconds,
          "YYYY-MM-DD"
        );
        this.supplierName = this.accountPayable.supplier.companyName;
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    calculatePriceMMK(apItem) {
      let priceMMK = apItem.price * this.accountPayable.exchangeRateMMK;
      apItem.priceMMK = parseFloat(priceMMK.toFixed(6));
    },
    calculateAmount(apItem) {
      if (this.isItemDiscount) {
        let discount = apItem.price * (apItem.discountPercent / 100);
        discount = parseFloat(discount.toFixed(6));
        apItem.amount = apItem.qty * (apItem.price - discount);
      } else {
        apItem.amount = apItem.qty * apItem.price;
      }
    },
    calculateAmountMMK(apItem) {
      let amountMMK = apItem.amount * this.accountPayable.exchangeRateMMK;
      apItem.amountMMK = parseFloat(amountMMK.toFixed(6));
    },
    changePaidPercent(apItem) {
      this.checkPaidPercentValid(apItem);
      this.calculatePaidAmount(apItem);
      this.calculateCashAmount();
    },

    checkPaidPercentValid(apItem) {
      let remainingPercent = 100 - apItem.prevPaidPercent;
      if (apItem.paidPercent > remainingPercent) {
        const product = "Product (" + apItem.productName + ")'s";
        const remaining = "remaining percent (" + remainingPercent + "%).";
        this.responseError = product + " Paid % is greater than " + remaining;
        this.messageDialogBox = true;
        return false;
      }
      return true;
    },
    calculatePaidAmount(apItem) {
      let paidAmount = apItem.amount * (apItem.paidPercent / 100);
      apItem.paidAmount = parseFloat(paidAmount.toFixed(6));
    },
    calculateCashAmount() {
      let cashAmount = 0;
      this.accountPayable.accountPayableItemList.forEach((item) => {
        cashAmount += item.paidAmount;
      });
      this.accountPayable.accountPayableDetailAssetList.forEach((item) => {
        cashAmount += item.paidAmount;
      });
      this.accountPayable.cashAmount = parseFloat(cashAmount.toFixed(6));
      this.calculateCashAmountMMK();
    },
    calculateCashAmountMMK() {
      let cashAmountMMK =
        this.accountPayable.cashAmount * this.accountPayable.exchangeRateMMK;
      this.accountPayable.cashAmountMMK = parseFloat(cashAmountMMK.toFixed(6));
    },
    checkCashAmountValid() {
      if (this.isPaymentType()) {
        if (this.accountPayable.cashAmount > this.totalPayableAmount) {
          this.responseError =
            "Cash Amount must not be greater than Total Payable Amount.";
          this.messageDialogBox = true;
          return false;
        }
      }
      return true;
    },
    calculateTotalPayableAmount() {
      let totalAmount = 0;
      this.accountPayable.accountPayableItemList.forEach((item) => {
        totalAmount += item.amount - item.prevPaidAmount;
      });
      this.accountPayable.accountPayableDetailAssetList.forEach((item) => {
        totalAmount += item.amount - item.prevPaidAmount;
      });
      this.totalPayableAmount = parseFloat(totalAmount.toFixed(6));
      this.calculateTotalPayableAmountMMK();
    },
    calculateTotalPayableAmountMMK() {
      let exchangeRateMMK = this.accountPayable.exchangeRateMMK;
      let totalPayableAmountMMK = this.totalPayableAmount * exchangeRateMMK;
      this.totalPayableAmountMMK = parseFloat(totalPayableAmountMMK.toFixed(6));
    },

    changeExchangeRateMMK() {
      this.accountPayable.accountPayableItemList.forEach((item) => {
        this.calculatePriceMMK(item);
        this.calculateAmountMMK(item);
      });
      this.accountPayable.accountPayableDetailAssetList.forEach((item) => {
        this.calculatePriceMMK(item);
        this.calculateAmountMMK(item);
      });
      this.calculateCashAmountMMK();
      this.calculateTotalPayableAmountMMK();
    },

    toggleDiscount() {
      if (this.isItemDiscount) {
        this.accountPayable.isItemDiscount = true;
      } else {
        this.accountPayable.isItemDiscount = false;
      }
      this.calculateTotalPayableAmount();
    },

    addDeleteAccountPayableItemId(deleteApItemId) {
      if (deleteApItemId) {
        if (!this.accountPayable.deleteAccountPayableItemIds) {
          this.accountPayable.deleteAccountPayableItemIds = [];
        }
        this.accountPayable.deleteAccountPayableItemIds.push(deleteApItemId);
      }
    },
    addDeleteAccountPayableAssetId(deleteApItemId) {
      if (deleteApItemId) {
        if (!this.accountPayable.deleteAccountPayableDetailAssetIds) {
          this.accountPayable.deleteAccountPayableDetailAssetIds = [];
        }
        this.accountPayable.deleteAccountPayableDetailAssetIds.push(
          deleteApItemId
        );
      }
    },
    removeAccountPayableItem(productId, accountPayableItemId) {
      this.addDeleteAccountPayableItemId(accountPayableItemId);
      let index = this.accountPayable.accountPayableItemList.findIndex(
        (v) => v.productId === productId
      );
      this.$delete(this.accountPayable.accountPayableItemList, index);
      this.calculateCashAmount();
      this.calculateTotalPayableAmount();
    },

    removeAccountPayableAssetItem(assetId, accountPayableItemId) {
      this.addDeleteAccountPayableAssetId(accountPayableItemId);
      let index = this.accountPayable.accountPayableDetailAssetList.findIndex(
        (v) => v.assetId === assetId
      );
      this.$delete(this.accountPayable.accountPayableDetailAssetList, index);
      this.calculateCashAmount();
      this.calculateTotalPayableAmount();
    },

    clearAccountPayableItemList() {
      this.accountPayable.accountPayableItemList.forEach((item) => {
        this.addDeleteAccountPayableItemId(item.id);
      });
      this.accountPayable.accountPayableDetailAssetList.forEach((item) => {
        this.addDeleteAccountPayableAssetId(item.id);
      });
      this.accountPayable.accountPayableItemList = [];
      this.accountPayable.accountPayableDetailAssetList = [];
    },
    changeShop() {
      this.accountPayable.poNo = "";
      this.accountPayable.advancedIssueNo = "";
      this.clearAccountPayableItemList();
    },

    clearAdvanceNo() {
      this.accountPayable.advancedIssueNo = "";
      this.accountPayable.exchangeRateMMK = 1;
    },

    changeAdvancedAccountPayable(advancedAP) {
      this.accountPayable.advancedIssueNo = advancedAP.issueNo;
      this.accountPayable.exchangeRateMMK = advancedAP.exchangeRateMMK;
      if (this.accountPayable.apType == "ADVANCE_REPAYMENT") {
        this.accountPayable.cashAmount = advancedAP.remainingAmount;
        this.calculateCashAmountMMK();
      }
      this.showAdvancedAPListDialog = !this.showAdvancedAPListDialog;
    },

    changeType() {
      this.accountPayable.advancedIssueNo = "";
    },

    isPaymentType() {
      return (
        this.accountPayable.apType == "PURCHASE_PAYMENT" ||
        this.accountPayable.apType == "ADVANCE_PURCHASE_PAYMENT" ||
        this.accountPayable.apType == "DISCOUNT"
      );
    },
    isAdvancePayment() {
      return (
        this.accountPayable.apType == "ADVANCE_PURCHASE_PAYMENT" ||
        this.accountPayable.apType == "ADVANCE_REPAYMENT"
      );
    },
    isSupplierAdvanced() {
      return this.accountPayable.apType == "SUPPLIER_ADVANCED";
    },
    isAdvanceRepay() {
      return this.accountPayable.apType == "ADVANCE_REPAYMENT";
    },
    isOperationSetting(){
      return(
        this.accountPayable.apType == "PURCHASE_PAYMENT" ||
        this.accountPayable.apType == "SUPPLIER_ADVANCED" ||
        this.accountPayable.apType == "ADVANCE_REPAYMENT"
      );
    },
    changeOperationType(){
      if(this.accountPayable.apType == "PURCHASE_PAYMENT"){
        this.type = "PURCHASE_PAYMENT";
        this.getOperationSettingList()
      }else if(this.accountPayable.apType == "SUPPLIER_ADVANCED"){
        this.type = "SUPPLIER_ADVANCED";
        this.getOperationSettingList()
      }else if(this.accountPayable.apType == "ADVANCE_REPAYMENT"){
        this.type = "SUPPLIER_ADVANCE_REPAYMENT";
        this.getOperationSettingList()
      }else {
        this.accountPayable.operationSettingId = null;
      }
    },
    getOperationSettingList() {
      operationSettingService
        .getOperationSettingListByType(this.type)
        .then((res) => {
          this.operationSettingList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
